import { DatePipe, DecimalPipe } from '@angular/common';
import {
  Component,
  effect,
  inject,
  input,
  signal,
  untracked,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BooleanPipe } from '@core/pipes/boolean.pipe';
import { KontoComponent } from '@features/konto/konto.component';
import { Kunde } from '@features/kunder/kunde.model';
import { LetregisterService } from '@features/letregister/letregister.service';
import { LetsikringAfIndtaegt } from '@features/letregister/letsikring-af-indtaegt.model';
import { LetsikringOpsparetVaerdi } from '@features/letregister/letsikring-opsparet-vaerdi.model';
import { LetsikringRevision } from '@features/letregister/letsikring-revision.model';
import { Letsikring } from '@features/letregister/letsikring.model';
import { DetailRowComponent } from '@shared/detail-row/detail-row.component';
import { ButtonModule } from 'primeng/button';
import { Checkbox } from 'primeng/checkbox';
import { InputNumber } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { KundeSelectorComponent } from '../../../../shared/kunde-selector/kunde-selector.component';
import { LetDatePickerComponent } from '../../../../shared/let-datepicker/let-date-picker.component';
import { DokumentService } from '@features/dokumenter/dokument.service';

@Component({
  selector: 'app-letsikring-af-indtaegt',
  imports: [
    DatePipe,
    BooleanPipe,
    DecimalPipe,
    ReactiveFormsModule,
    DetailRowComponent,
    InputTextModule,
    InputNumber,
    ButtonModule,
    Checkbox,
    Select,
    KontoComponent,
    LetDatePickerComponent,
    KundeSelectorComponent,
  ],
  templateUrl: './letsikring-af-indtaegt.component.html',
  styleUrl: './letsikring-af-indtaegt.component.css',
})
export class LetsikringAfIndtaegtComponent {
  form = input.required<FormGroup>();
  editMode = input.required<boolean>();
  revision = input.required<LetsikringRevision>();
  letsikring = input.required<Letsikring>();
  letsikringAfIndtaegt = input.required<LetsikringAfIndtaegt>();

  opsparetVaerdi = signal<LetsikringOpsparetVaerdi | undefined>(undefined);

  dokumentService = inject(DokumentService);
  letregisterService = inject(LetregisterService);

  constructor() {
    effect(async () => {
      const ls = this.letsikring();
      untracked(async () => {
        const ov = await this.letregisterService.opsparetVaerdi(ls);
        this.opsparetVaerdi.set(ov);
      });
    });
  }

  loebendeIndbetalingFrekvensOptions = [
    { text: 'Hver 14. dag', value: 'FjortenDages' },
    { text: 'Månedlig', value: 'Maanedlig' },
    { text: 'Kvartårlig', value: 'KvartAarlig' },
    { text: 'Halvårlig', value: 'HalvAarlig' },
    { text: 'Årlig', value: 'Aarlig' },
  ];

  skatteKortTypeOptions = [
    { text: 'Bikort', value: 'Bikort' },
    { text: 'Hovedkort', value: 'Hovedkort' },
    { text: 'Frikort', value: 'Frikort' },
  ];

  depotsikringIndbetalingstypeOptions = [
    { text: 'Indbetalingsaftale', value: 'Indbetalingsaftale' },
    { text: '§41', value: 'Paragraf41' },
    { text: 'Hovedkort', value: 'Konto' },
  ];

  investeringsprofilOptions = [
    { text: 'Profil Forsigtig', value: 'A' },
    { text: 'Profil Lav', value: 'B' },
    { text: 'Profil Middel', value: 'C' },
    { text: 'Profil Høj', value: 'D' },
    { text: 'Fleksibel', value: 'V' },
  ];

  getInvesteringprofilText(value?: string) {
    const found = this.investeringsprofilOptions.filter(x => x.value === value);
    if (found.length > 0) {
      return found[0].text;
    }
    return '';
  }

  onMedforsikredeSelected(kunde: Kunde) {
    this.form().patchValue({
      gaeldendeRevision: {
        letsikringAfIndtaegt: {
          medforsikredeId: kunde.id,
          medforsikredeNavn: kunde.navn,
        },
      },
    });
  }
}
